import { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";

interface IPropsCheckedValues {
  roleEmail: boolean;
  roleMobile: boolean;
  candidateEmail: boolean;
  candidateMobile: boolean;
  platformEmail: boolean;
  platformMobile: boolean;
}

const Communications = () => {
  const [checkedValues, setCheckedValues] = useState<IPropsCheckedValues>({
    roleEmail: false,
    roleMobile: false,
    candidateEmail: false,
    candidateMobile: false,
    platformEmail: false,
    platformMobile: false,
  });

  const handleChecked = (isChecked: boolean, checkedTitle: string) => {
    setCheckedValues({...checkedValues, [checkedTitle]: isChecked});
  }

  const handleSaveCommunicationsSetting = () => {
    // trigger save data here
    // console.log(checkedValues);
  }

  return (
    <Card className="border-slate-200 shadow-sm">
      <CardContent className="p-xl space-y-lg">
        <div>
          <h3 className="font-serif text-2xl text-slate-900 dark:text-slate-100 mb-sm">
            Communication Preferences
          </h3>
          <p className="text-sm text-slate-600 dark:text-slate-400">
            Choose how you'd like to receive notifications
          </p>
        </div>

        <Table>
          <TableHeader>
            <TableRow className="bg-slate-50 dark:bg-slate-800">
              <TableHead className="font-serif text-base">Notification Type</TableHead>
              <TableHead className="text-center">Email</TableHead>
              <TableHead className="text-center">Mobile</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            <TableRow className="hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors">
              <TableCell className="font-medium">Role Notifications</TableCell>
              <TableCell className="text-center">
                <div className="flex justify-center">
                  <Switch
                    checked={checkedValues?.roleEmail}
                    onCheckedChange={(checked) => handleChecked(checked, "roleEmail")}
                  />
                </div>
              </TableCell>
              <TableCell className="text-center">
                <div className="flex justify-center">
                  <Switch
                    checked={checkedValues?.roleMobile}
                    onCheckedChange={(checked) => handleChecked(checked, "roleMobile")}
                  />
                </div>
              </TableCell>
            </TableRow>
            <TableRow className="hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors">
              <TableCell className="font-medium">Candidate Notifications</TableCell>
              <TableCell className="text-center">
                <div className="flex justify-center">
                  <Switch
                    checked={checkedValues?.candidateEmail}
                    onCheckedChange={(checked) => handleChecked(checked, "candidateEmail")}
                  />
                </div>
              </TableCell>
              <TableCell className="text-center">
                <div className="flex justify-center">
                  <Switch
                    checked={checkedValues?.candidateMobile}
                    onCheckedChange={(checked) => handleChecked(checked, "candidateMobile")}
                  />
                </div>
              </TableCell>
            </TableRow>
            <TableRow className="hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors">
              <TableCell className="font-medium">Platform Announcements</TableCell>
              <TableCell className="text-center">
                <div className="flex justify-center">
                  <Switch
                    checked={checkedValues?.platformEmail}
                    onCheckedChange={(checked) => handleChecked(checked, "platformEmail")}
                  />
                </div>
              </TableCell>
              <TableCell className="text-center">
                <div className="flex justify-center">
                  <Switch
                    checked={checkedValues?.platformMobile}
                    onCheckedChange={(checked) => handleChecked(checked, "platformMobile")}
                  />
                </div>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>

        <div className="flex justify-end pt-lg border-t border-slate-200 dark:border-slate-700">
          <Button
            size="sm"
            variant="default"
            onClick={handleSaveCommunicationsSetting}
            className="min-w-[120px]"
          >
            Save Changes
          </Button>
        </div>
      </CardContent>
    </Card>
  )
}

export default Communications;
